import styled from 'styled-components';

const InheritedColorLink = styled.a`
	color: inherit;
`;

export default InheritedColorLink;

export const NoUnderScoreLink = styled(InheritedColorLink)`
	text-decoration: none;
`;

// For a link without href, so can show the underscore
export const UnderScoreLink = styled.a`
	text-decoration: underline;

	&:hover {
		cursor: pointer;
	}
`;
